import Vue from 'vue';
export default {
  data() {
    return {
      confirmType: 0,
      //tabs
      editInfoTabClass: 'menu-top-items active-tab',
      timeTabClass: 'menu-top-items',
      moreTabClass: 'menu-top-items',
      otherOrgnanClass: 'menu-top-items',
      noteTabClass: 'menu-top-items',
      addressTabClass: 'menu-top-items',
      doctorInsideTabClass: 'menu-top-items',
      noteInsideTabClass: 'menu-top-items',
      colorTags: [
        { title: 'red', id: 1, color: '#1EAA6E' },
        { title: 'blue', id: 2, color: '#792554' },
        { title: 'orange', id: 3, color: '#D7712D' },
        { title: 'green', id: 4, color: '#E15858' },
      ],
      tab: 'one',
      patientLat: null,
      patientLng: null,
      EditMissionPhoneI: null,
      editMissionRank: null,
      editMissionRecoveryPhone: '',
      editMissionChiefComplaint: null,
      editMissionDiagnosis: null,
      editMissionTag: null,
      editMissionOtherOrganizations: null,
      editMissionChiefNote: null,
      editMissionCity: null,
      editMissionAddress: '',
      editMissionVehicleType: null,
      editMissionVehicleTypeCount: null,
      listOfEditMissionSelectedCodes: [],
      editMissionNote: '',
      editMissionPatientFirstName: '',
      editMissionPatientLastName: '',
      editMissionPatientGender: null,
      editMissionPatientRelation: null,
      editMissionPatientAgeYear: null,
      editMissionPatientAgeMonth: null,
      editMissionPatientNationalCode: null,
      editMissionPatientAgeDay: null,
      editMissionIsPatientNewBorn: false,
      editMissionNumberOfPatient: null,
      missionTimes: [],
      missionLakeCodeList: [],
      otherCallerIdList: [],
      tenNineteenModal: false,
      editMissionTenNineteenNote: '',
      editMissionSelectedCancleReason: null,
      stateDataTableItems: [],
      stateDataTableHeader: [],
      //admission
      admissionDataTableHeader: [],
      admissionDataTableItems: [],
      otherOrganDataTableHeader: [],
      otherOrganDataTableItems: [],
      //note
      noteText: '',
      noteList: [],
      disabelNoteConfirm: false,
      addressDataTableHeader: [],
      addressDataTableItems: [],
      insideTab: 1,
      passedTimeFromCallInterval: null,
      passedTimeFromDispatchInterval: null,
      mapSingleMovingIconInterval: null,
      //doctor
      allDoctorOrders: [],
      polyline: {
        latlngs: [],
        color: '#49454F',
      },
      pathsList: [],
      latLngsPathList: [],
      selectedEndCallObj: {
        endCallType: null,
        missionId: null,
      },
    };
  },
  methods: {
    setConfirmModal: function (type, endCallType, missionId) {
      this.confirmType = 0;
      this.$refs.confirm_modal.showConfirmDialog = true;
      if (endCallType === 4) {
        this.$refs.confirm_modal.title = 'ثبت پیوست';
        this.$refs.confirm_modal.text = 'آیا از ثبت نتیجه پیوست اطمینان دارید؟';
      } else if (endCallType === 5) {
        this.$refs.confirm_modal.title = 'ثبت پیگیری';
        this.$refs.confirm_modal.text = 'آیا از ثبت نتیجه پیگیری اطمینان دارید؟';
      }
      this.selectedEndCallObj.endCallType = endCallType;
      this.selectedEndCallObj.missionId = missionId;
    },
    setConfirmModalConfirmation: function (uniqueId_NewCall = '') {
      switch (this.confirmType) {
        case 0:
          this.endCallFunction("edit", this.selectedEndCallObj.endCallType, this.selectedEndCallObj.missionId, uniqueId_NewCall);
          break;
        case 1:
          this.setMissionStateAs10_60(
            this.missionId,
            this.missionPhoneId,
            this.closeEdit115MissionFunction(uniqueId_NewCall ?? ''),
            '10-60 اقدام شد'
          );
          break;
        case 2:
          this.setMissionStateAs10_60(
            this.missionId,
            this.missionPhoneId,
            this.closeEdit115MissionFunction(uniqueId_NewCall ?? ''),
            "10-33(115)"
          );
          break;
        case 3:
          this.setMissionStateAs10_60(
            this.missionId,
            this.missionPhoneId,
            this.closeEdit115MissionFunction(uniqueId_NewCall ?? ''),
            "10-99(115)"
          );
          break;

        default:
          break;
      }
      this.onDenyConfirmation();
    },
    onDenyConfirmation: function () {
      this.$refs.confirm_modal.showConfirmDialog = false;
    },
    changeTab: function (data) {
      this.tab = data;
      if (this.tab == 'one') {
        this.editInfoTabClass = 'menu-top-items active-tab';
        this.timeTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.otherOrgnanClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (this.tab == 'two') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items active-tab';
        this.moreTabClass = 'menu-top-items';
        this.otherOrgnanClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
        this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (this.tab == 'three') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items active-tab';
        this.otherOrgnanClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        if (this.missionPhoneId) {
          this.getAllPatientDoctorDetailFunction(this.missionPhoneId);
        }
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (this.tab == 'four') {
        this.mapInvalidate();
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.otherOrgnanClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items active-tab';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.getAllMissionAddressLogFunction(this.missionId);
        if (this.phoneId) {
          this.getPhoneOnlineLocationFunction(this.phoneId);
          this.mapSingleMovingIconInterval = setInterval(() => {
            this.getPhoneOnlineLocationFunction(this.phoneId);
          }, 4000);
        }
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (this.tab == 'five') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.otherOrgnanClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items active-tab';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.getAllMissionNoteFunction(this.missionId, this.missionPhoneId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (this.tab == 'six') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.otherOrgnanClass = 'menu-top-items active-tab';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        if (this.missionPhoneId) {
          this.getMissionPhoneOtherOrganizationFunction(this.missionId);
          this.getMissionPhoneAdmissionHistoryFunction(this.missionPhoneId);
        }
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (this.tab == 'seven') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.otherOrgnanClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items active-tab';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        if (this.missionId) {
          this.getMissionCallsfunction(this.missionId);
        }
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      }
    },
    set10_60Confirmation: function (type) {
      if (type == 1) {
        this.confirmType = type;
        this.$refs.confirm_modal.showConfirmDialog = true;
        this.$refs.confirm_modal.title = 'ثبت 60-10';
        this.$refs.confirm_modal.text = 'آیا از ثبت 60-10 اطمینان دارید؟';
      } else if (type == 2) {
        this.confirmType = type;
        this.$refs.confirm_modal.showConfirmDialog = true;
        this.$refs.confirm_modal.title = 'ثبت 33-10';
        this.$refs.confirm_modal.text = 'آیا از ثبت 33-10 اطمینان دارید؟';
      } else if (type == 3) {
        this.confirmType = type;
        this.$refs.confirm_modal.showConfirmDialog = true;
        this.$refs.confirm_modal.title = 'ثبت 99-10';
        this.$refs.confirm_modal.text = 'آیا از ثبت 99-10 اطمینان دارید؟';
      }
    },
    addCodeForMission: function () {
      if (!this.editMissionVehicleType) {
        this.snackText = 'لطفا نوع کد را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (
        this.editMissionVehicleTypeCount === null ||
        this.editMissionVehicleTypeCount === undefined ||
        this.editMissionVehicleTypeCount === ''
      ) {
        this.snackText = ' لطفا تعداد ' + this.editMissionVehicleType.title + ' را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.listOfEditMissionSelectedCodes.length > 0) {
        for (let i = 0; i < this.listOfEditMissionSelectedCodes.length; i++) {
          if (this.listOfEditMissionSelectedCodes[i].id == this.editMissionVehicleType.id) {
            this.snackText = ' کد ' + this.editMissionVehicleType.title + ' قبلا انتخاب شده است';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            return;
          }
        }
      }
      this.listOfEditMissionSelectedCodes.push({
        title: this.editMissionVehicleType.title,
        count: this.editMissionVehicleTypeCount,
        id: this.editMissionVehicleType.id,
      });
      this.editMissionVehicleType = null;
      this.editMissionVehicleTypeCount = null;
    },
    removeCodeFromMission: function (id) {
      for (let i = 0; i < this.listOfEditMissionSelectedCodes.length; i++) {
        if (this.listOfEditMissionSelectedCodes[i].id == id) {
          this.listOfEditMissionSelectedCodes.splice(i, 1);
        }
      }
    },
    setToopackForMission: function (toopack) {
      let id = '';
      if (this.missionPhoneId) {
        id = this.missionPhoneId.toString();
        id = id + this.missionId.toString();
      } else {
        id = this.missionId.toString();
      }
      localStorage.setItem(id, toopack.color);
      this.snackText = 'برچسب با موفقیت ثبت شد.';
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#4CAF50';
      this.snakIcon = 'mdi-check-circle';
    },
    cleanForm: function () {
      clearInterval(this.mapSingleMovingIconInterval);
      this.editMissionRank = null;
      this.editMissionRecoveryPhone = '';
      this.editMissionChiefComplaint = null;
      this.editMissionDiagnosis = null;
      this.editMissionTag = null;
      this.editMissionOtherOrganizations = null;
      this.editMissionChiefNote = null;
      this.editMissionCity = null;
      this.editMissionAddress = '';
      this.editMissionVehicleType = null;
      this.editMissionVehicleTypeCount = null;
      this.listOfEditMissionSelectedCodes = [];
      this.editMissionNote = '';
      this.editMissionPatientFirstName = '';
      this.editMissionPatientLastName = '';
      this.editMissionPatientGender = null;
      this.editMissionPatientRelation = null;
      this.editMissionPatientAgeYear = null;
      this.editMissionPatientAgeMonth = null;
      this.editMissionPatientNationalCode = null;
      this.missionLakeCodeList = [];
      this.otherCallerIdList = [];
      this.polyline = {
        latlngs: [],
        color: '#49454F',
      };
    },
    closeEdit115MissionFunction: function (uniqueId_NewCall = "") {
      try {
        this.$root.$refs.Home.playerHome = false;
      } catch (error) { console.log(error); }
      try {
        clearInterval(this.mapSingleMovingIconInterval);
        this.cleanForm();
        if (this.type == "fromMainList") {
          this.$root.$refs.Mission115View.edit115MissionModal = false;
          this.getListOfCurrentMissionFunction();
        } else if (this.type == "fromNewCall") {
          this.$root.$refs[`newCallComponent_${uniqueId_NewCall}`].currentMissionModal = false;
        }
        this.changeToOldTitle();
      } catch (error) {
        console.log("error : ", error);
      }
    },
    //10-19
    showTenNineteenModal: function () {
      this.getListOfCancelReasons();
      this.tenNineteenModal = true;
    },
    cancelSetCancleReaonFor115Mission: function () {
      this.editMissionSelectedCancleReason = null;
      this.editMissionTenNineteenNote = '';
      this.tenNineteenModal = false;
    },
    setCancelReasonNote: function () {
      this.editMissionTenNineteenNote = this.editMissionSelectedCancleReason;
    },
    //time
    readyTimeData: function (data) {
      this.missionTimes = [];
      let finishTime = '-';
      let arriveToStationTime = '-';
      let patientDeliveryTime = '-';
      let arriveToHospitalTime = '-';
      let moveFromLocationTime = '-';
      let arriveToLocationTime = '-';
      let moveFromStationTime = '-';
      let deliveryTime = '-';
      let pickupTime = '-';
      let ringTime = '-';
      let passedFromCallTime = '-';
      let passedFromDispatchTime = '-';
      if (data.finishTime) {
        finishTime = Vue.moment(data.finishTime).format('HH:mm:ss');
      }
      if (data.arriveToStationTime) {
        arriveToStationTime = Vue.moment(data.arriveToStationTime).format('HH:mm:ss');
      }
      if (data.patientDeliveryTime) {
        patientDeliveryTime = Vue.moment(data.patientDeliveryTime).format('HH:mm:ss');
      }
      if (data.arriveToHospitalTime) {
        arriveToHospitalTime = Vue.moment(data.arriveToHospitalTime).format('HH:mm:ss');
      }
      if (data.moveFromLocationTime) {
        moveFromLocationTime = Vue.moment(data.moveFromLocationTime).format('HH:mm:ss');
      }
      if (data.arriveToLocationTime) {
        arriveToLocationTime = Vue.moment(data.arriveToLocationTime).format('HH:mm:ss');
      }
      if (data.moveFromStationTime) {
        moveFromStationTime = Vue.moment(data.moveFromStationTime).format('HH:mm:ss');
      }
      if (data.deliveryTime) {
        deliveryTime = Vue.moment(data.deliveryTime).format('HH:mm:ss');
      }
      if (data.pickupTime) {
        pickupTime = Vue.moment(data.pickupTime).format('HH:mm:ss');
      }
      if (data.ringTime) {
        ringTime = Vue.moment(data.ringTime).format('HH:mm:ss');
      }
      this.missionTimes.push(
        {
          title: 'زمان تماس',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: ringTime,
          id: 1,
          size: 3,
        },
        {
          title: 'زمان پاسخ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: pickupTime,
          id: 2,
          size: 3,
        },
        {
          title: 'زمان گذشته از تماس',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: passedFromCallTime,
          id: 3,
          size: 3,
        },
        {
          title: 'زمان گذشته از ابلاغ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: passedFromDispatchTime,
          id: 4,
          size: 3,
        },
        {
          title: 'دریافت ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: deliveryTime,
          id: 5,
          size: 3,
        },
        {
          title: 'حرکت از پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromStationTime,
          id: 6,
          size: 3,
        },
        {
          title: 'رسیدن به فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToLocationTime,
          id: 7,
          size: 3,
        },
        {
          title: 'حرکت از فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromLocationTime,
          id: 8,
          size: 3,
        },
        {
          title: 'رسیدن به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToHospitalTime,
          id: 9,
          size: 3,
        },
        {
          title: 'تحویل به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: patientDeliveryTime,
          id: 10,
          size: 3,
        },
        {
          title: 'پایان ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: finishTime,
          id: 13,
          size: 3,
        },
        {
          title: 'رسیدن به پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToStationTime,
          id: 12,
          size: 3,
        },

      );
      if (data.ringTime) {
        let date1 = new Date(data.currentTime);
        let date2 = new Date(data.ringTime);
        let dd = date1.getTime() - date2.getTime();
        this.passedTimeFromCallInterval = setInterval(() => {
          dd = dd + 1000;
          this.missionTimes[2].text = this.msToTime(dd);
        }, 1000);
      }
      if (data.dispatchTime) {
        let date1 = new Date(data.currentTime);
        let date2 = new Date(data.dispatchTime);
        let dd = date1.getTime() - date2.getTime();
        this.passedTimeFromDispatchInterval = setInterval(() => {
          dd = dd + 1000;
          this.missionTimes[3].text = this.msToTime(dd);
        }, 1000);
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;

      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    readyStateData: function (data) {
      this.stateDataTableHeader = [
        { text: 'وضعیت', value: 'state', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.stateDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.stateDataTableItems.push({
          state: data[i].state ? data[i].state : '-',
          date: date,
          note: data[i].note ? data[i].note : '-',
          user: user,
        });
      }
    },
    //other organ
    readyOtherOrganization: function (data) {
      this.otherOrganDataTableHeader = [
        { text: 'عنوان', value: 'title', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
      ];
      this.otherOrganDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        if (data[i].requestDate) {
          date = Vue.moment(data[i].requestDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.otherOrganDataTableItems.push({
          title: data[i].otherOrganization ? data[i].otherOrganization?.title : '-',
          date: date,
        });
      }
    },
    //admission
    readyAdmissionData: function (data) {
      this.admissionDataTableHeader = [
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          sortable: false,
        },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.admissionDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.admissionDataTableItems.push({
          hospital: data[i].hospital ? data[i].hospital.title : '-',
          date: date,
          user: user,
        });
      }
    },
    //doctor
    readyDoctorData: function (data) {
      this.allDoctorOrders = [];
      for (let i = 0; i < data.length; i++) {
        let patient = '';
        if (data[i].patient) {
          let fName = data[i].patient.firstName ? data[i].patient.firstName : '-';
          let lName = data[i].patient.lastName ? data[i].patient.lastName : '-';
          patient = fName + ' ' + lName;
        }
        this.allDoctorOrders.push({
          patient: patient,
          doctorInfoDataTableHeader: [],
          doctorInfoDataTableItems: [],
          doctorDrugDataTableHeader: [],
          doctorDrugDataTableItems: [],
          doctorOrderDataTableHeader: [],
          doctorOrderDataTableItems: [],
        });
        const mainLength = this.allDoctorOrders.length - 1;
        this.allDoctorOrders[mainLength].doctorInfoDataTableHeader = [
          {
            text: 'تشخیص',
            value: 'dignosis',
            align: 'center',
            sortable: false,
          },
          { text: 'نتیجه', value: 'result', align: 'center', sortable: false },
          { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
          { text: 'پزشک', value: 'doctor', align: 'center', sortable: false },
        ];
        this.allDoctorOrders[mainLength].doctorDrugDataTableHeader = [
          { text: 'نام دارو', value: 'drug', align: 'center', sortable: false },
          { text: 'تعداد', value: 'count', align: 'center', sortable: false },
          {
            text: 'نحوه تجویز',
            value: 'useage',
            align: 'center',
            sortable: false,
          },
          {
            text: 'دستور استفاده',
            value: 'standBy',
            align: 'center',
            sortable: false,
          },
        ];
        this.allDoctorOrders[mainLength].doctorOrderDataTableHeader = [
          {
            text: 'اقدامات درمانی',
            value: 'actions',
            align: 'center',
            sortable: false,
          },
        ];
        let doctor = '';
        if (data[i].doctor) {
          let fName = data[i].doctor.firstName ? data[i].doctor.firstName : '-';
          let lName = data[i].doctor.lastName ? data[i].doctor.lastName : '-';
          doctor = fName + ' ' + lName;
        }
        this.allDoctorOrders[mainLength].doctorInfoDataTableItems.push({
          dignosis: data[i].diagnosis ? data[i].diagnosis : '-',
          result: data[i].result ? data[i].result : '-',
          note: data[i].note ? data[i].note : '-',
          doctor: doctor,
        });
        for (let j = 0; j < data[i].patientDoctorOrders.length; j++) {
          let standBy = 'استفاده شود';
          if (data[i].patientDoctorOrders[j].isStandby) {
            standBy = 'آماده استفاده';
          }
          this.allDoctorOrders[mainLength].doctorDrugDataTableItems.push({
            drug: data[i].patientDoctorOrders[j].drug
              ? data[i].patientDoctorOrders[j].drug.title
              : '-',
            count: data[i].patientDoctorOrders[j].dosage
              ? data[i].patientDoctorOrders[j].dosage
              : '-',
            useage: data[i].patientDoctorOrders[j].drugOrderType
              ? data[i].patientDoctorOrders[j].drugOrderType.title
              : '-',
            standBy: standBy,
          });
        }
        for (let j = 0; j < data[i].patientDoctorActions.length; j++) {
          this.allDoctorOrders[mainLength].doctorOrderDataTableItems.push({
            actions: data[i].patientDoctorActions[j] ? data[i].patientDoctorActions[j].title : '-',
          });
        }
      }
    },
    // map&&address
    flyToPosition: function (lat, lng) {
      this.$refs.modalmap.mapObject.flyTo([lat, lng], 16);
    },
    //note tab
    readyNoteData: function (data) {
      this.noteList = [];
      for (let i = 0; i < data.length; i++) {
        let user = '';
        let date = '';
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        if (data[i].noteDate) {
          date = Vue.moment(data[i].noteDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.noteList.push({
          user: user,
          date: date,
          note: data[i].note ? data[i].note : '-',
          id: data[i].id,
        });
      }
    },
    noteHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.addNote();
      }
    },
    addNote: function () {
      this.disabelNoteConfirm = true;
      if (!this.noteText) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      if (!this.noteText.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      this.addNoteToMissionFucntion(this.noteText, this.missionId, this.missionPhoneId);
    },
    readyAddressLogData: function (data) {
      this.addressDataTableHeader = [
        { text: 'آدرس', value: 'address', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.addressDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.addressDataTableItems.push({
          date: date,
          address: data[i].address ? data[i].address : '-',
          user: user,
        });
      }
    },
    showLine: function () {
      if (this.missionPhoneId) {
        this.getMissionPhoneLocationsFunction(this.missionPhoneId);
      }
    },
    toRadians(degrees) {
      return (degrees * Math.PI) / 180;
    },

    // Converts from radians to degrees.
    toDegrees(radians) {
      return (radians * 180) / Math.PI;
    },
    bearing(startLat, startLng, destLat, destLng) {
      startLat = this.toRadians(startLat);
      startLng = this.toRadians(startLng);
      destLat = this.toRadians(destLat);
      destLng = this.toRadians(destLng);
      const y = Math.sin(destLng - startLng) * Math.cos(destLat);
      const x =
        Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
      let brng = Math.atan2(y, x);
      brng = this.toDegrees(brng);
      return (brng + 360) % 360;
    },
    setStoppedPositionState: function (speed, state) {
      if (speed < 2 && !state) {
        return {
          state: 'در حال توقف',
        };
      } else if (speed === 0 && !state) {
        return {
          state: 'توقف',
        };
      }
      return {
        state,
      };
    },
    loadPath: function (data) {
      if (data.length) {
        this.pathsList = [...data]?.map((eachLocation, index) => {
          if (index > 0) {
            delete eachLocation['angle'];
            const preLat = data[index - 1]?.latitude;
            const preLng = data[index - 1]?.longitude;
            return {
              ...eachLocation,
              bearing: this.bearing(preLat, preLng, eachLocation.latitude, eachLocation.longitude),
            };
          }
          return {
            ...eachLocation,
          };
        });
      }
      const latLngsList = [...this.pathsList].map(({ latitude, longitude }) => {
        return [latitude, longitude];
      });
      this.latLngsPathList = latLngsList;
      this.ShowAntPath(latLngsList);
    },
    callToPatient: function (number) {
      if (number) {
        let data = {
          missionId: this.missionId,
          missionPhoneId: this.missionPhoneId,
          to: number,
        };
        this.callToPatientFunction(data);
      }
    },
  },
  computed: {
    isMapReady() {
      return !!(
        this.$refs.modalmap &&
        this.$refs.modalmap.mapObject &&
        this.patientLat &&
        this.patientLng &&
        this.tab === 'four'
      );
    },
  },
};
